<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label" for="steueridentifikationsnummer{{index}}">
      {{ 'COMMON_UI.STEUERIDENTIFIKATION.STEUERIDENTIFIKATIONSNUMMER' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="steueridentifikationsnummer{{objectId}}" formControlName="steueridentifikationsnummer"
             id="steueridentifikationsnummer{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row" *ngIf="showWirtschaftsIdNummer">
    <label class="col-sm-4 col-form-label" for="wirtschaftsIdNummer{{index}}">
      {{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="wirtschaftsIdNummer{{objectId}}" formControlName="wirtschaftsIdNummer"
             id="wirtschaftsIdNummer{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsValidationMessage/>
    </div>
  </div>

</form>
